import { PATH } from './constants/router'
import React from 'react'
const Splash = React.lazy(() => import('./page/Splash/index'))
const InsurenceMotobike = React.lazy(() => import('./page/InsuranceMotobike/index'))
const InsuranceObligatoryOto = React.lazy(() => import('./page/InsuranceObligatoryOto/index'))
const BookingHistory = React.lazy(() => import('./page/BookingHistory/index'))
const BookingDetail = React.lazy(() => import('./page/BookingDetail/index'))
const ReferStation = React.lazy(() => import('./page/ReferStation/index'))

export const ROUTERS = {
  //page on ZALO app
  homePage: {
    path: PATH.HOME,
    component: Splash,
    isZaloApp: 1
  },
  bookingInsurence: {
    path: PATH.INSURENCE_MOTO,
    component: InsurenceMotobike,
    isZaloApp: 1
  },
  myBookingHistory: {
    path: PATH.BOOKING_HYSTORY,
    component: BookingHistory,
    isZaloApp: 1
  },
  zaloOrderDetail: {
    path: PATH.BOOKING_DETAIL,
    component: BookingDetail,
    isZaloApp: 1
  },
  obligatoryInsurent: {
    path: PATH.INSURENCE_OBLIGATORY,
    component: InsuranceObligatoryOto,
    isZaloApp: 1
  },
    referStationZalo: {
    path: PATH.REFER_STATION,
    component: ReferStation,
    isZaloApp: 1,
  },
  // page on web
  splash: {
    path: PATH.HOME,
    component: Splash,
    isZaloApp: 0
  },
  insurence: {
    path: PATH.INSURENCE_MOTO,
    component: InsurenceMotobike,
    isZaloApp: 0
  },
  bookingHistory: {
    path: PATH.BOOKING_HYSTORY,
    component: BookingHistory,
    isZaloApp: 0
  },
  orderDetail: {
    path: PATH.BOOKING_DETAIL,
    component: BookingDetail,
    isZaloApp: 0
  },
  obligatory: {
    path: PATH.INSURENCE_OBLIGATORY,
    component: InsuranceObligatoryOto,
    isZaloApp: 0
  },
  referStation: {
    path: PATH.REFER_STATION,
    component: ReferStation,
    isZaloApp: 0,
  }
}
const isZaloApp = process.env.REACT_APP_ZALO_AUTH_ENABLE * 1
export const fillterRoutes = Object.entries(ROUTERS)
  .filter(([key, route]) => route.isZaloApp === isZaloApp)
  .reduce((obj, [key, route]) => {
    obj[key] = route
    return obj
  }, {})
